import { TooltipButton } from '@/ui/TooltipButton';
import styled from 'styled-components';
import { Icon } from '@/icons';
import type { IconButtonProps } from '@/ui/IconButton/IconButton';

const Tool = styled(TooltipButton)`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  min-height: 38px;
  padding: 8px 10px;
  font: inherit;
  font-size: ${({ theme }) => theme.fontSize.xs};
  border: 1px solid ${({ theme }) => theme.color.glassBorder};
  border-radius: ${({ theme }) => theme.radius.md};
  color: ${({ theme }) => theme.color.textMuted};
  background: transparent;
  cursor: pointer;
  svg {
    color: ${({ theme }) => theme.color.accentCyan};
    flex-shrink: 0;
  }
  &:hover {
    background: ${({ theme }) => theme.color.hover};
  }
  &:disabled,
  &[aria-disabled='true'] {
    opacity: 0.5;
    cursor: not-allowed;
  }
  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.color.focusRing};
    outline-offset: 2px;
  }
`;
const labels: Record<string, string> = {
  'Add image': 'Add media',
  'Add video': 'Video',
  'Add poll': 'Poll',
  'Remove poll': 'Remove poll',
  'Add emoji': 'Emoji',
  'Schedule post': 'Schedule',
};
export function ComposerTool({
  icon,
  label,
  size = 18,
  type = 'button',
  text,
  ...props
}: IconButtonProps & { text?: string }) {
  return (
    <Tool type={type} aria-label={label} data-composer-tool {...props}>
      <Icon name={icon} size={size} />
      <span>{text ?? labels[label] ?? label}</span>
    </Tool>
  );
}
